/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionFetchRequestDto } from './SectionFetchRequestDto';
import {
    SectionFetchRequestDtoFromJSON,
    SectionFetchRequestDtoFromJSONTyped,
    SectionFetchRequestDtoToJSON,
    SectionFetchRequestDtoToJSONTyped,
} from './SectionFetchRequestDto';

/**
 * 
 * @export
 * @interface FetchSectionsDataRequestDto
 */
export interface FetchSectionsDataRequestDto {
    /**
     * 
     * @type {Array<SectionFetchRequestDto>}
     * @memberof FetchSectionsDataRequestDto
     */
    sections: Array<SectionFetchRequestDto>;
}

/**
 * Check if a given object implements the FetchSectionsDataRequestDto interface.
 */
export function instanceOfFetchSectionsDataRequestDto(value: object): value is FetchSectionsDataRequestDto {
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function FetchSectionsDataRequestDtoFromJSON(json: any): FetchSectionsDataRequestDto {
    return FetchSectionsDataRequestDtoFromJSONTyped(json, false);
}

export function FetchSectionsDataRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchSectionsDataRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sections': ((json['sections'] as Array<any>).map(SectionFetchRequestDtoFromJSON)),
    };
}

export function FetchSectionsDataRequestDtoToJSON(json: any): FetchSectionsDataRequestDto {
    return FetchSectionsDataRequestDtoToJSONTyped(json, false);
}

export function FetchSectionsDataRequestDtoToJSONTyped(value?: FetchSectionsDataRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sections': ((value['sections'] as Array<any>).map(SectionFetchRequestDtoToJSON)),
    };
}

